// 仓库、质检、维修、销售共用本次驳回确认；恢复状态只由后端决定。
export default {
    computed: {
        rejectHandoverEnabled() {
            const capability = this.$store.state.saasInfo && this.$store.state.saasInfo.edition_capability;
            return !capability || capability.has_handover !== false;
        }
    },
    methods: {
        isSourceRejectPending(data) {
            return this.$options.handoverModuleType === 0
                ? !!data.buttons?.confirm_reject?.visible
                : Number(data.handover_state) === 9;
        },
        sourceHandoverStateText(data) {
            if (this.hasHandover === false) return '';
            return {6: '已调出', 8: '调拨中', 9: '被驳回中', 5: '已返库'}[data.handover_state] || '';
        },
        canConfirmReject(data) {
            return !!data.buttons?.confirm_reject?.visible;
        },
        canCancelReject(data) {
            return !!data.buttons?.cancel_reject?.visible;
        },
        cancelReject(data) {
            if (!this.canCancelReject(data)) return;
            this.$confirm({
                message: '撤销本次驳回？',
                buttonName: '确认',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/handover/reject/cancel',
                        data: {id: data.id},
                        loading: true,
                        success: (result, msg) => {
                            this.$message({message: msg || '撤销成功', type: 'success'});
                            this.$refs.view.update();
                        },
                        fail: (code, result, msg) => {
                            this.$message({message: msg || '操作失败，请刷新后重试', type: 'warn'});
                            this.$refs.view.update();
                            return false;
                        },
                        error: () => {
                            this.$refs.view.update();
                        }
                    });
                }
            });
        },
        confirmReject(rows) {
            const list = rows ? (Array.isArray(rows) ? rows : [rows]) : [];
            if (!list.length) {
                this.$message({message: '请选择需要同意驳回的商品', type: 'warn'});
                return;
            }
            if (list.some(item => !item.reject_handover_id || !this.canConfirmReject(item))) {
                this.$message({message: '请选择可同意驳回的被驳回中商品', type: 'warn'});
                return;
            }
            this.$confirm({
                message: '确定同意驳回所选的' + list.length + '条记录？',
                buttonName: '同意驳回',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: list.length === 1 ? '/handover/reject/confirm' : '/handover/reject/batchConfirm',
                        data: list.length === 1 ? {id: list[0].reject_handover_id} : {ids: list.map(item => item.reject_handover_id)},
                        loading: true,
                        success: (results, msg) => {
                            this.$refs.view.update();
                            const failed = Array.isArray(results) ? results.filter(item => !item.success) : [];
                            if (failed.length) {
                                const details = failed.map(item => {
                                    const row = list.find(row => String(row.reject_handover_id) === String(item.id));
                                    return (row ? row.produce_unique_code : '') + '：' + item.message;
                                }).join('；');
                                this.$confirm({message: msg + '。' + details, buttonName: '知道了', cancelButton: false});
                            } else {
                                this.$message({message: msg, type: 'success'});
                            }
                        },
                        fail: (code, result, msg) => {
                            this.$message({message: msg, type: 'warn'});
                            this.$refs.view.update();
                            return false;
                        },
                        error: () => {
                            this.$refs.view.update();
                        }
                    });
                }
            });
        }
    }
};
